<script>
export default {
  name: 'AlertUpdateAsset',
  props: {
    date: { type: String, default: '' },
    noSpacing: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      numberDayReference: -5,
    }
  },

  computed: {
    daysAfter() {
      const split = this.date.split('D')
      const daysAfter = Math.floor(split[1])
      return daysAfter
    },

    afterDays() {
      if (!this.date || !this.date.length) {
        return false
      }

      return this.daysAfter < this.numberDayReference
    },
  },
}
</script>

<template>
  <v-tooltip v-if="afterDays" bottom :class="{ 'ml-1': !noSpacing }">
    <template v-slot:activator="{ on }">
      <v-chip color="red" x-small text-color="white" v-on="on">
        {{ date }}
      </v-chip>
    </template>
    <span>
      Ativo está a {{ Math.abs(daysAfter) }} dias sem atualizar o P/L. Verifique
      seus dados ou Importe-o novamente</span
    >
  </v-tooltip>
</template>
